import React from 'react';
import CommunityBasicInfoComponent from './community-basic-info.component';
import { UploadMedia } from '../../../../../common/components/common/upload-media';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import FroumGroupsValuesComponent from './community-forum-info.component';



export const MyCommunityComponent = ({  selectedTopic,handleLike,handleDislike, setSelectedTopic,setAddItem,addItem,closeModal,handleSaveItem,handleEdit, additionButtons, back, selectedCommunity }: any) => {

  const tabItems = [
    // {
    //   id: 1,
    //   title: 'Basic-Info',
    //   component: (
    //     <CommunityBasicInfoComponent
    //       selectedCommunity={selectedCommunity}
    //     />
    //   ),
    //   isVisible: true,
    // },

    {
      id: 1,
      title: 'Forum Groups',
      component:
        <FroumGroupsValuesComponent
          additionButtons={additionButtons}
          handleEdit={handleEdit}
          handleSaveItem={handleSaveItem}
            selectedCommunity={selectedCommunity}
            setAddItem={setAddItem}
            addItem={addItem}
            closeModal={closeModal}
            selectedTopic={selectedTopic}
             setSelectedTopic={setSelectedTopic}
                    handleLike ={handleLike}
             handleDislike = {handleDislike}
        />,
      isVisible: true,
    },

 

  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
      
      </div>
    </div>
  )
}
export default MyCommunityComponent;